var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.104,
    height: 71.104,
    viewBox: "0 0 71.104 71.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Print",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M60.971,17.731V1.125H12.383V17.731A11.866,11.866,0,0,0,1.125,29.567V58.008H11.2v-4.74H5.865v-23.7a7.118,7.118,0,0,1,7.11-7.11h47.4a7.118,7.118,0,0,1,7.11,7.11v23.7H60.971v4.74H72.229V29.567A11.866,11.866,0,0,0,60.971,17.731Zm-4.74-.015H17.123V5.865H56.231Z",
    transform: "translate(-1.125 -1.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M52.747,14.063h4.74V18.8h-4.74ZM11.269,23.543H5.344v4.74h5.925V57.91H51.562V28.283h5.925v-4.74ZM46.821,53.17H16.009V28.283H46.821Z",
    transform: "translate(3.545 13.194)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.0c77a817b0dc5c34940f1bc9a44d0753.svg";
export { ForwardRef as ReactComponent };